import dayjs from 'dayjs'

/**
 * csrf-Tokenを取得
 * @returns csrf-Token
 * @throws {Error} エラーメッセージ
 */
/* istanbul ignore next */
export const getCsrfToken = (): string => {
  const csrfToken: HTMLMetaElement | null = document.querySelector('meta[name="csrf-token"]')
  if (csrfToken === null) {
    throw new Error('csrf-tokenがセットされていません')
  }
  return csrfToken.content
}

/**
 * 生まれ年の選択肢を配列で取得
 */
export const getBirthYearOptions = (): {
  value: number
  label: string
}[] => {
  const min = 1930
  const max = dayjs().tz().year()
  const options = []
  for (let i = min; i <= max; i++) {
    options.push({ value: i, label: String(i) })
  }
  return options
}

/**
 * フォトグラファーの生まれ年の選択肢を配列で取得
 */
export const getPhotographerBirthYearOptions = (): {
  value: number
  label: string
}[] => {
  const min = new Date().getFullYear() - 75
  const max = new Date().getFullYear() - 18
  const options = []
  for (let i = min; i <= max; i++) {
    options.push({ value: i, label: String(i) })
  }
  return options
}

/**
 * 生まれ月の選択肢を配列で取得
 */
export const getBirthMonthOptions = (): {
  value: number
  label: string
}[] => {
  const min = 1
  const max = 12
  const options = []
  for (let i = min; i <= max; i++) {
    options.push({ value: i, label: String(i) })
  }
  return options
}

/**
 * 生まれ日の選択肢を配列で取得
 */
export const getBirthDayOptions = (): {
  value: number
  label: string
}[] => {
  const min = 1
  const max = 31
  const options = []
  for (let i = min; i <= max; i++) {
    options.push({ value: i, label: String(i) })
  }
  return options
}

/**
 * クレジットカード有効期限(年)の選択肢を取得
 */
export const getExpireYearOptions = (
  currentYear: number
): {
  value: string
  label: string
}[] => {
  return [...Array(16)].map((_, index) => {
    const year = String(currentYear + index)
    return { value: year, label: year }
  })
}
/**
 * クレジットカード有効期限(月)の選択肢を取得
 */
export const getExpireMonthOptions = (): {
  value: string
  label: string
}[] => {
  return [...Array(12)].map((_, index) => {
    const month = String(index + 1).padStart(2, '0')
    return { value: month, label: month }
  })
}

/**
 * URL生成
 */
export const createToUrl = (path: string, params: Record<string, string | number | undefined>): string => {
  let url = path
  const urlSearchParams = new URLSearchParams()
  for (const key in params) {
    const value = params[key]
    if (value === undefined || value === '') {
      continue
    }
    urlSearchParams.append(key, String(value))
  }
  if (urlSearchParams.toString().length > 0) {
    url += '?' + urlSearchParams.toString()
  }
  return url
}

/**
 * 最初のエラー位置までスクロール
 */
export const scrollToFirstError = (selectors = '.form-item-error'): void => {
  const firstError = document.querySelector(selectors)
  if (!firstError) return
  const target = firstError.closest('.form-item') ?? firstError
  scrollTo(0, target.getBoundingClientRect().top + window.pageYOffset)
}

/**
 * --content-heightを設定
 * @param element
 */
export const setContentHeight = (el: Element) => {
  const element = el as HTMLElement
  element.style.setProperty('--content-height', element.scrollHeight + 'px')
}
